import React from "react";

const Loading = () => {
  return (
    <div className="fixed inset-0 flex justify-center items-center  bg-opacity-30 z-[1000]">
      <div className="bg-transparent p-6 rounded-lg shadow-md flex justify-center items-center w-48 h-48">
        <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default Loading;
